import Masonry from 'masonry-layout';
import imagesLoaded from 'imagesloaded';
import { debounce } from './helpers';

const isViewportNearElementBottom = (element) => {
    const rect = element.getBoundingClientRect();
    const windowHeight = window.innerHeight || document.documentElement.clientHeight;
    const offset = windowHeight > 550 ? windowHeight : 550;

    const isBottomNearView = rect.bottom - windowHeight <= offset;

    return isBottomNearView;
};

const galleryContainer = document.querySelector('.js-masonry');
if (galleryContainer) {
    document.addEventListener('DOMContentLoaded', () => {

        // Create Masonry
        const masonryOptions = {
            columnWidth: '.js-grid-sizer',
            itemSelector: '.gallery-item',
            gutter: '.js-gutter-sizer',
            transitionDuration: 0
        };
        const imageGallery = new Masonry(galleryContainer, masonryOptions);

        // Load Images on scroll
        let currentIndex = 0;
        let loadingImages = false;
        const ITEMS_PER_PAGE = 10;
        const galleryItems = galleryContainer.querySelectorAll('.js-masonry-item');
        const scrollHandler = debounce(() => {
            if (isViewportNearElementBottom(galleryContainer) && !loadingImages) {
                loadGalleryItems(galleryItems, ITEMS_PER_PAGE);
            }
        }, 80);

        function loadGalleryItems(items, numberOfItemsToLoad) {
            loadingImages = true;
            const appendedItems = [];
            for (let i = currentIndex; (i < items.length) && (i < currentIndex + numberOfItemsToLoad); i++) {
                let $this = items[i];
                let imageURL = $this.dataset.img;
                if (imageURL) {
                    const img = $this.querySelector('.js-lazy-load-img');
                    img.src = imageURL;

                }
                appendedItems.push($this);
            }
            // console.log(appendedItems);

            imagesLoaded(appendedItems, function () {
                loadingImages = false;
                currentIndex += numberOfItemsToLoad;
                if (currentIndex >= galleryItems.length) {
                    window.removeEventListener('scroll', scrollHandler);
                    window.removeEventListener('resize', scrollHandler);
                }
                setTimeout(() => {
                    for (let i = 0; i < appendedItems.length; i++) {
                        appendedItems[i].classList.add('show');
                        appendedItems[i].classList.remove('hidden');
                    }
                    imageGallery.layout();
                }, 25);
            });

        }

        // Load More Gallery Items on scroll and also check resize
        window.addEventListener('load', scrollHandler);
        window.addEventListener('scroll', scrollHandler, {passive: true});
        window.addEventListener('resize', scrollHandler, {passive: true});
    });
}
